// /home/ananun/fluorescence.pro/admin/src/helpers/auth.jsx
// auth.jsx

import { useContext, createContext } from "react";

export const isLoggedIn = createContext();

export function useAuth() {
  return useContext(isLoggedIn);
}
